import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './app';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { AppUserProvider } from './providers/appUserContext';
import { registerServiceWorker } from "./registerServiceWorker";

// Only register service worker in production to avoid caching issues during development
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    navigator.serviceWorker.register('/sw.js');
  } else {
    // Unregister service worker in development to avoid stale cache issues
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  }
}

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN ?? ''}
      clientId={process.env.REACT_APP_AUTH0_CLIENTID ?? ''}
      redirectUri={`${window.location.origin}/orgs`}
      audience={process.env.REACT_APP_AUTH0_AUDIENCE}
      cacheLocation='localstorage'
      useRefreshTokens={true}
      scope="openid profile email offline_access">
        <AppUserProvider>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
      </AppUserProvider>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
